<template>
  <div>
    <DividerSeparator class="wide">
      <Loader />
      <div slot="title">Logging You Out</div>
    </DividerSeparator>
    <Request
      v-if="logoutRoutes"
      v-for="(route, key, index) in logoutRoutes"
      v-on:finished="onFinished"
      :key="key"
      :index="index"
      :url="route"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import Request from "@/components/partials/logout/Request";
import Loader from "vue-spinner/src/BounceLoader";

export default {
  name: "auth-logout",
  components: { Request, Loader },
  computed: {
    ...mapGetters("config", {
      logoutRoutes: "getLogoutRoutes"
    })
  },
  data: function() {
    return {
      finishedCount: 0
    };
  },
  watch: {
    logoutRoutes(routes) {
      if (routes || Object.keys(routes).length === 0) {
        this.redirectAfterLogin();
      }
    }
  },
  methods: {
    ...mapActions("user", {
      redirectAfterLogin: "redirectAfterLogin"
    }),
    ...mapActions("config", {
      getLogoutRoutesData: "getLogoutRoutesData"
    }),
    onFinished(index) {
      if (this.logoutRoutes) {
        this.logoutRoutes.splice(index, 1);
        if (this.logoutRoutes.length === 0) {
          this.redirectAfterLogin();
        }
      }
    }
  },
  mounted: function() {
    this.services.AuthService.logout({ q: Date.now() }).then(() => {
      if (!this.logoutRoutes || Object.keys(this.logoutRoutes).length === 0) {
        setTimeout(() => {
          this.getLogoutRoutesData();
        }, 1000);
      }
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
